import { lazy, Suspense } from "react";
import PayperviewCategoryskeleton from "components/skeleton/PayperviewCategoryskeleton";

const PayPerViewCategoryCard = lazy(() => import("./PayPerViewCategoryCard"));

function CategoryGridView({ categories, isLoading }: any) {
  return (
    <>
      {!isLoading && (
        <Suspense fallback={<PayperviewCategoryskeleton />}>
          <div className="grid w-full grid-cols-3 gap-3 pt-5 mt-4 max-sm:grid-cols-2">
            {categories &&
              categories.map((category: any, i: number) => (
                <div key={i}>
                  <PayPerViewCategoryCard category={category} />
                </div>
              ))}
          </div>
        </Suspense>
      )}
      {isLoading && <PayperviewCategoryskeleton />}
    </>
  );
}

export default CategoryGridView;
